import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiV1 } from "../Auth/Interceptor";
import { v4 as uuidv4 } from 'uuid';

const initialStateValue = {
    media: {
        media: {},
        loading: 'idle',
        error: null,
    },
    storefront: {
        storefront: {},
        loading: 'idle',
        error: null,
    },
    storefrontAbout: {
        storefrontAbout: {},
        loading: 'idle',
        error: null,
    },
    propsType: {
        publish: false,
        saved: false
    },
    buttonClick: false,
    viewType: 'DESKTOP',
    pageType:  'STORE',
    sectionType: null,
    zoomSize: 100,
    sectionFormType: null,
    modal: {
        type: null,
        open: false,
    },
    selectedCarouselBannerSection: 'Banner 1',
    selectedFeatureOneSection: 'Feature 1',
    selectedFeatureTwoSection: 'Feature 1',
    selectedDesktopFeatureOneSection: 'Feature 1',
    selectedDesktopFeatureTwoSection: 'Feature 1',

    editLinkedList: [],
    desktopEditLinkedList: [],

    versionStack: [],
    versionIndex: 0,
    desktopVersionStack: [],
    desktopVersionIndex: 0,

    categoryCollectionToEdit: null,
    customCollectionToEdit: null,
    categoryToEdit: null,
    mediaSelectionType: null,
    displayPreview: {
        type: null,
        open: false,
    },
    changeType: null,
    pageTypeDropdownOpen: false,
};

const fetchMedia = createAsyncThunk('storefront/fetchMedia', async () => {
    try {
        const response = await apiV1.get('media/getAll');
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
});

const fetchStorefront = createAsyncThunk('storefront/fetchStorefront', async () => {
    try {
        const response = await apiV1.get('storefront');
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
});

const fetchStorefrontAbout = createAsyncThunk('storefront/fetchStorefrontAbout', async () => {
    try {
        const response = await apiV1.get('storefrontabout');
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
});

const storefrontSlice = createSlice({
    name: "storefront",
    initialState: initialStateValue,
    reducers: {
        setProps: (state, action) => {
            state.propsType = action.payload;
        },
        toggleButtonClick: (state) => {
            state.buttonClick = !state.buttonClick;
        },
        setViewtype: (state, action) => {
            state.viewType = action.payload;
        },
        setPagetype: (state, action) => {
            state.pageType = action.payload;
        },
        setSectionType: (state, action) => {
            state.sectionType = action.payload;
            state.sectionFormType = null;
        },
        updateZoomSize: (state, action) => {
            state.zoomSize = action.payload;
        },
        setSectionFormType: (state, action) => {
            state.sectionFormType = action.payload;
        },
        setModal: (state, action) => {
            state.modal.type = action.payload;
            state.modal.open = true;
        },
        closeModal: (state, _) => {
            state.modal.type = null;
            state.modal.open = false;
        },
        setSelectedCarouselBannerSection: (state, action) => {
            state.selectedCarouselBannerSection = action.payload;
        },
        setSelectedFeatureOneSection: (state, action) => {
            state.selectedFeatureOneSection = action.payload;
        },
        setSelectedFeatureTwoSection: (state, action) => {
            state.selectedFeatureTwoSection = action.payload;
        },
        setSelectedDesktopFeatureOneSection: (state, action) => {
            state.selectedDesktopFeatureOneSection = action.payload;
        },
        setSelectedDesktopFeatureTwoSection: (state, action) => {
            state.selectedDesktopFeatureTwoSection = action.payload;
        },
        setEditLinkedList: (state, action) => {
            state.editLinkedList = action.payload;
        },
        setDesktopEditLinkedList: (state, action) => {
            state.desktopEditLinkedList = action.payload;
        },
        moveSectionUp: (state, action) => {
            const { item: webItem, mobileItem: item } = action.payload;

            const currentVersion = JSON.parse(JSON.stringify(state.versionStack[state.versionIndex]));
            const linkedList = currentVersion.versionData;
            const webLinkedList = currentVersion.webVersionData;

            const toReplaceWith = linkedList.find(node => node.next === item.prev);
            const toReplaceWebWith = webLinkedList.find(node => node.next === webItem.prev);
            const updateNextOf = linkedList.find(node => node.next === toReplaceWith.prev);
            const updateWebNextOf = webLinkedList.find(node => node.next === toReplaceWebWith.prev);

            let temp = { ...item };
            let tempWeb = { ...webItem };
            let temp2 = { ...toReplaceWith };
            let tempWeb2 = { ...toReplaceWebWith };

            temp.prev = toReplaceWith.prev;
            tempWeb.prev = toReplaceWebWith.prev;

            temp.next = toReplaceWith.next;
            tempWeb.next = toReplaceWebWith.next;

            temp2.prev = item.prev;
            tempWeb2.prev = webItem.prev;

            temp2.next = item.next;
            tempWeb2.next = webItem.next;

            const itemIndex = linkedList.findIndex(node => node.id === item.id);
            const webItemIndex = webLinkedList.findIndex(node => node.id === webItem.id);
            const toReplaceWithIndex = linkedList.findIndex(node => node.id === toReplaceWith.id);
            const toReplaceWebWithIndex = webLinkedList.findIndex(node => node.id === toReplaceWebWith.id);

            linkedList[itemIndex] = temp2;
            webLinkedList[webItemIndex] = tempWeb2;
            linkedList[toReplaceWithIndex] = temp;
            webLinkedList[toReplaceWebWithIndex] = tempWeb;

            if(updateNextOf) {
                let temp3 = { ...updateNextOf };
                temp3.next = toReplaceWith.prev;
                const updateNextOfIndex = linkedList.findIndex(node => node === updateNextOf);
                linkedList[updateNextOfIndex] = temp3;
            }

            if(updateWebNextOf) {
                let tempWeb3 = { ...updateWebNextOf };
                tempWeb3.next = toReplaceWebWith.prev;
                const updateWebNextOfIndex = webLinkedList.findIndex(node => node === updateWebNextOf);
                webLinkedList[updateWebNextOfIndex] = tempWeb3;
            }

            const versionList = JSON.parse(JSON.stringify(state.versionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                index: newIndex,
                versionData: linkedList,
                webVersionData: webLinkedList,
                comment: 'Move section up',
            }

            state.versionStack.push(newVersion);
            state.versionIndex = newIndex;
        },
        moveDesktopSectionUp: (state, action) => {
            const item = action.payload;

            const currentVersion = JSON.parse(JSON.stringify(state.desktopVersionStack[state.desktopVersionIndex]));
            const linkedList = currentVersion.versionData;

            const toReplaceWith = linkedList.find(node => node.next === item.prev);
            const updateNextOf = linkedList.find(node => node.next === toReplaceWith.prev);

            let temp = { ...item };
            let temp2 = { ...toReplaceWith };

            temp.prev = toReplaceWith.prev;
            temp.next = toReplaceWith.next;
            temp2.prev = item.prev;
            temp2.next = item.next;

            const itemIndex = linkedList.findIndex(node => node.id === item.id);
            const toReplaceWithIndex = linkedList.findIndex(node => node.id === toReplaceWith.id);

            linkedList[itemIndex] = temp2;
            linkedList[toReplaceWithIndex] = temp;

            if(updateNextOf) {
                let temp3 = { ...updateNextOf };
                temp3.next = toReplaceWith.prev;
                const updateNextOfIndex = linkedList.findIndex(node => node === updateNextOf);
                linkedList[updateNextOfIndex] = temp3;
            }

            const versionList = JSON.parse(JSON.stringify(state.desktopVersionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                index: newIndex,
                versionData: linkedList,
                comment: 'Move desktop section up'
            }

            state.desktopVersionStack.push(newVersion);
            state.desktopVersionIndex = newIndex;
        },
        moveSectionDown: (state, action) => {
            const { item: webItem, mobileItem: item } = action.payload;

            const currentVersion = JSON.parse(JSON.stringify(state.versionStack[state.versionIndex]));
            const linkedList = currentVersion.versionData;
            const webLinkedList = currentVersion.webVersionData;

            const toReplaceWith = linkedList.find(node => node.prev === item.next);
            const toReplaceWebWith = webLinkedList.find(node => node.prev === webItem.next);
            const updatePrevOf = linkedList.find(node => node.prev === toReplaceWith.next);
            const updateWebPrevOf = webLinkedList.find(node => node.prev === toReplaceWebWith.next);

            let temp = { ...item };
            let tempWeb = { ...webItem };
            let temp2 = { ...toReplaceWith };
            let tempWeb2 = { ...toReplaceWebWith };

            temp.prev = toReplaceWith.prev;
            tempWeb.prev = toReplaceWebWith.prev;

            temp.next = toReplaceWith.next;
            tempWeb.next = toReplaceWebWith.next;

            temp2.prev = item.prev;
            tempWeb2.prev = webItem.prev;

            temp2.next = item.next;
            tempWeb2.next = webItem.next;

            const itemIndex = linkedList.findIndex(node => node.id === item.id);
            const webItemIndex = webLinkedList.findIndex(node => node.id === webItem.id);
            const toReplaceWithIndex = linkedList.findIndex(node => node.id === toReplaceWith.id);
            const toReplaceWebWithIndex = webLinkedList.findIndex(node => node.id === toReplaceWebWith.id);

            linkedList[itemIndex] = temp2;
            webLinkedList[webItemIndex] = tempWeb2;
            linkedList[toReplaceWithIndex] = temp;
            webLinkedList[toReplaceWebWithIndex] = tempWeb;

            if(updatePrevOf) {
                let temp3 = { ...updatePrevOf };
                temp3.prev = toReplaceWith.next;
                const updatePrevOfIndex = linkedList.findIndex(node => node === updatePrevOf);
                linkedList[updatePrevOfIndex] = temp3;
            }

            if(updateWebPrevOf) {
                let tempWeb3 = { ...updateWebPrevOf };
                tempWeb3.prev = toReplaceWebWith.next;
                const updateWebPrevOfIndex = webLinkedList.findIndex(node => node === updateWebPrevOf);
                webLinkedList[updateWebPrevOfIndex] = tempWeb3;
            }

            const versionList = JSON.parse(JSON.stringify(state.versionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                index: newIndex,
                versionData: linkedList,
                webVersionData: webLinkedList,
                comment: 'Move section down',
            }

            state.versionStack.push(newVersion);
            state.versionIndex = newIndex;
        },
        moveDesktopSectionDown: (state, action) => {
            const item = action.payload;

            const currentVersion = JSON.parse(JSON.stringify(state.desktopVersionStack[state.desktopVersionIndex]));
            const linkedList = currentVersion.versionData;

            const toReplaceWith = linkedList.find(node => node.prev === item.next);
            const updatePrevOf = linkedList.find(node => node.prev === toReplaceWith.next);

            let temp = { ...item };
            let temp2 = { ...toReplaceWith };

            temp.prev = toReplaceWith.prev;
            temp.next = toReplaceWith.next;
            temp2.prev = item.prev;
            temp2.next = item.next;

            const itemIndex = linkedList.findIndex(node => node.id === item.id);
            const toReplaceWithIndex = linkedList.findIndex(node => node.id === toReplaceWith.id);

            linkedList[itemIndex] = temp2;
            linkedList[toReplaceWithIndex] = temp;

            if(updatePrevOf) {
                let temp3 = { ...updatePrevOf };
                temp3.prev = toReplaceWith.next;
                const updatePrevOfIndex = linkedList.findIndex(node => node === updatePrevOf);
                linkedList[updatePrevOfIndex] = temp3;
            }
            state.editLinkedList = linkedList;

            const versionList = JSON.parse(JSON.stringify(state.desktopVersionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                index: newIndex,
                versionData: linkedList,
                comment: 'Move desktop section down'
            }

            state.desktopVersionStack.push(newVersion);
            state.desktopVersionIndex = newIndex;
        },
        addItemToLast: (state, action) => {
            const id = uuidv4();
            const item = action.payload;

            const currentVersion = JSON.parse(JSON.stringify(state.versionStack[state.versionIndex]));
            const linkedList = currentVersion.versionData;

            const lastItem = linkedList.find(node => node.next === null);
            let temp = { ...lastItem };
            temp.next = id;

            const newNode = {
                id,
                next: null,
                prev: lastItem ? id : null,
                item,
            }

            const lastItemIndex = linkedList.findIndex(node => node.id === lastItem.id);

            linkedList[lastItemIndex] = temp;
            linkedList.push(newNode);

            state.editLinkedList = linkedList;

            const versionList = JSON.parse(JSON.stringify(state.versionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                index: newIndex,
                versionData: linkedList,
                comment: 'Add store section'
            }

            state.versionStack.push(newVersion);
            state.versionIndex = newIndex;
        },
        addDesktopItemToLast: (state, action) => {
            const id = uuidv4();
            const item = action.payload;

            const currentVersion = JSON.parse(JSON.stringify(state.versionStack[state.versionIndex]));
            const linkedList = currentVersion.versionData;
            const webLinkedList = currentVersion.webVersionData;

            const lastItem = linkedList.find(node => node.next === null);
            const lastWebItem = webLinkedList.find(node => node.next === null);
            let temp = { ...lastItem };
            let tempWeb = { ...lastWebItem };
            temp.next = id;
            tempWeb.next = id;

            const newNode = {
                id,
                next: null,
                prev: lastItem ? id : null,
                item,
            }

            const newWebNode = {
                id,
                next: null,
                prev: lastWebItem ? id : null,
                item,
            }

            const lastItemIndex = linkedList.findIndex(node => node.id === lastItem.id);
            const lastWebItemIndex = webLinkedList.findIndex(node => node.id === lastWebItem.id);

            linkedList[lastItemIndex] = temp;
            webLinkedList[lastWebItemIndex] = tempWeb;
            linkedList.push(newNode);
            webLinkedList.push(newWebNode);

            const versionList = JSON.parse(JSON.stringify(state.versionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                index: newIndex,
                versionData: linkedList,
                webVersionData: webLinkedList,
                comment: 'Add desktop store section'
            }

            state.versionStack.push(newVersion);
            state.versionIndex = newIndex;
        },
        addAboutItemToLast: (state, action) => {
            const id = uuidv4();
            const item = action.payload;

            const currentVersion = JSON.parse(JSON.stringify(state.versionStack[state.versionIndex]));
            const linkedList = currentVersion.storeAbout;

            const lastItem = linkedList.find(node => node.next === null);
            let temp = { ...lastItem };
            temp.next = id;

            const newNode = {
                id,
                next: null,
                prev: lastItem ? id : null,
                item,
            }

            const lastItemIndex = linkedList.findIndex(node => node.id === lastItem.id);

            linkedList[lastItemIndex] = temp;
            linkedList.push(newNode);

            const versionList = JSON.parse(JSON.stringify(state.versionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                index: newIndex,
                storeAbout: linkedList,
                comment: 'Add about section'
            }

            state.versionStack.push(newVersion);
            state.versionIndex = newIndex;
        },
        addDesktopAboutItemToLast: (state, action) => {
            const id = uuidv4();
            const item = action.payload;

            const currentVersion = JSON.parse(JSON.stringify(state.versionStack[state.versionIndex]));
            const linkedList = currentVersion.storeAbout;
            const webLinkedList = currentVersion.webStoreAbout;

            const lastItem = linkedList.find(node => node.next === null);
            const lastWebItem = webLinkedList.find(node => node.next === null);
            let temp = { ...lastItem };
            let tempWeb = { ...lastWebItem };
            temp.next = id;
            tempWeb.next = id;

            const newNode = {
                id,
                next: null,
                prev: lastItem ? id : null,
                item,
            }

            const newWebNode = {
                id,
                next: null,
                prev: lastWebItem ? id : null,
                item,
            }

            let lastItemIndex;
            let lastWebItemIndex;

            if(currentVersion?.length === 0) {
                lastItemIndex = 0;
                lastWebItemIndex = 0;
            }
            else {
                lastItemIndex = linkedList.findIndex(node => node.id === lastItem.id);
                lastWebItemIndex = webLinkedList.findIndex(node => node.id === lastWebItem.id);
            }

            linkedList[lastItemIndex] = temp;
            webLinkedList[lastWebItemIndex] = tempWeb;
            linkedList.push(newNode);
            webLinkedList.push(newWebNode);

            const versionList = JSON.parse(JSON.stringify(state.versionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                index: newIndex,
                storeAbout: linkedList,
                webStoreAbout: webLinkedList,
                comment: 'Add desktop about section'
            }

            state.versionStack.push(newVersion);
            state.versionIndex = newIndex;
        },
        removeSection: (state, action) => {
            const { item: webItem, mobileItem: item } = action.payload;

            const currentVersion = JSON.parse(JSON.stringify(state.versionStack[state.versionIndex]));
            const linkedList = currentVersion.versionData;
            const webLinkedList = currentVersion.webVersionData;

            let newLinkedList = [];
            let newWebLinkedList = [];

            // Case 1: At the beginning (prev: null, next: "")
            if(!item.prev && item.next) {
                const nextNode = linkedList.find(node => node.prev === item.next);
                const nextWebNode = webLinkedList.find(node => node.prev === webItem.next);
                const temp = { ...nextNode };
                const tempWeb = { ...nextWebNode };

                temp.prev = null;
                tempWeb.prev = null;

                newLinkedList = linkedList.filter(node => node.id !== item.id);
                newWebLinkedList = webLinkedList.filter(node => node.id !== webItem.id);

                const nextIndex = newLinkedList.findIndex(node => node.id === nextNode.id);
                const nextWebIndex = newWebLinkedList.findIndex(node => node.id === nextWebNode.id);

                newLinkedList[nextIndex] = temp;
                newWebLinkedList[nextWebIndex] = tempWeb;
            }

            // Case 2: At the end (prev: "", next: null)
            if(item.prev && !item.next) {
                const prevNode = linkedList.find(node => node.next === item.prev);
                const prevWebNode = webLinkedList.find(node => node.next === webItem.prev);
                const temp = { ...prevNode };
                const tempWeb = { ...prevWebNode };

                temp.next = null;
                tempWeb.next = null;

                newLinkedList = linkedList.filter(node => node.id !== item.id);
                newWebLinkedList = webLinkedList.filter(node => node.id !== webItem.id);

                const prevIndex = newLinkedList.findIndex(node => node.id === prevNode.id);
                const prevWebIndex = newWebLinkedList.findIndex(node => node.id === prevWebNode.id);

                newLinkedList[prevIndex] = temp;
                newWebLinkedList[prevWebIndex] = tempWeb;
            }

            // Case 3: At the middle (prev: "", next: "")
            if(item.prev && item.next) {
                const linkId = uuidv4();

                const prevNode = linkedList.find(node => node.next === item.prev);
                const prevWebNode = webLinkedList.find(node => node.next === webItem.prev);
                const nextNode = linkedList.find(node => node.prev === item.next);
                const nextWebNode = webLinkedList.find(node => node.prev === webItem.next);

                const temp = { ...prevNode };
                const tempWeb = { ...prevWebNode };
                const temp2 = { ...nextNode };
                const tempWeb2 = { ...nextWebNode };

                temp.next = linkId;
                tempWeb.next = linkId;
                temp2.prev = linkId;
                tempWeb2.prev = linkId;

                newLinkedList = linkedList.filter(node => node.id !== item.id);
                newWebLinkedList = webLinkedList.filter(node => node.id !== webItem.id);

                const prevIndex = newLinkedList.findIndex(node => node.id === prevNode.id);
                const prevWebIndex = newWebLinkedList.findIndex(node => node.id === prevWebNode.id);
                const nextIndex = newLinkedList.findIndex(node => node.id === nextNode.id);
                const nextWebIndex = newWebLinkedList.findIndex(node => node.id === nextWebNode.id);

                newLinkedList[prevIndex] = temp;
                newWebLinkedList[prevWebIndex] = tempWeb;
                newLinkedList[nextIndex] = temp2;
                newWebLinkedList[nextWebIndex] = tempWeb2;
            }

            const versionList = JSON.parse(JSON.stringify(state.versionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                index: newIndex,
                versionData: newLinkedList,
                webVersionData: newWebLinkedList,
                comment: 'Remove store section',
            }

            state.versionStack.push(newVersion);
            state.versionIndex = newIndex;
        },
        removeDesktopSection: (state, action) => {
            const item = action.payload;

            const currentVersion = JSON.parse(JSON.stringify(state.desktopVersionStack[state.desktopVersionIndex]));
            const linkedList = currentVersion.versionData;

            let newLinkedList = [];

            // Case 1: At the beginning (prev: null, next: "")
            if(!item.prev && item.next) {
                const nextNode = linkedList.find(node => node.prev === item.next);
                const temp = { ...nextNode };

                temp.prev = null;

                newLinkedList = linkedList.filter(node => node.id !== item.id);

                const nextIndex = newLinkedList.findIndex(node => node.id === nextNode.id);

                newLinkedList[nextIndex] = temp;
            }

            // Case 2: At the end (prev: "", next: null)
            if(item.prev && !item.next) {
                const prevNode = linkedList.find(node => node.next === item.prev);
                const temp = { ...prevNode };

                temp.next = null;

                newLinkedList = linkedList.filter(node => node.id !== item.id);

                const prevIndex = newLinkedList.findIndex(node => node.id === prevNode.id);

                newLinkedList[prevIndex] = temp;
            }

            // Case 3: At the middle (prev: "", next: "")
            if(item.prev && item.next) {
                const linkId = uuidv4();

                const prevNode = linkedList.find(node => node.next === item.prev);
                const nextNode = linkedList.find(node => node.prev === item.next);

                const temp = { ...prevNode };
                const temp2 = { ...nextNode };

                temp.next = linkId;
                temp2.prev = linkId;

                newLinkedList = linkedList.filter(node => node.id !== item.id);

                const prevIndex = newLinkedList.findIndex(node => node.id === prevNode.id);
                const nextIndex = newLinkedList.findIndex(node => node.id === nextNode.id);

                newLinkedList[prevIndex] = temp;
                newLinkedList[nextIndex] = temp2;
            }

            const versionList = JSON.parse(JSON.stringify(state.desktopVersionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                index: newIndex,
                versionData: newLinkedList,
                comment: 'Remove desktop store section'
            }

            state.desktopVersionStack.push(newVersion);
            state.desktopVersionIndex = newIndex;
        },
        removeAboutSection: (state, action) => {
            const { item: webItem, mobileItem: item } = action.payload;

            const currentVersion = JSON.parse(JSON.stringify(state.versionStack[state.versionIndex]));
            const linkedList = currentVersion.storeAbout;
            const webLinkedList = currentVersion.webStoreAbout;

            let newLinkedList = [];
            let newWebLinkedList = [];

            // Case 1: At the beginning (prev: null, next: "")
            if(!item.prev && item.next) {
                const nextNode = linkedList.find(node => node.prev === item.next);
                const nextWebNode = webLinkedList.find(node => node.prev === webItem.next);
                const temp = { ...nextNode };
                const tempWeb = { ...nextWebNode };

                temp.prev = null;
                tempWeb.prev = null;

                newLinkedList = linkedList.filter(node => node.id !== item.id);
                newWebLinkedList = webLinkedList.filter(node => node.id !== webItem.id);

                const nextIndex = newLinkedList.findIndex(node => node.id === nextNode.id);
                const nextWebIndex = newWebLinkedList.findIndex(node => node.id === nextWebNode.id);

                newLinkedList[nextIndex] = temp;
                newWebLinkedList[nextWebIndex] = tempWeb;
            }

            // Case 2: At the end (prev: "", next: null)
            if(item.prev && !item.next) {
                const prevNode = linkedList.find(node => node.next === item.prev);
                const prevWebNode = webLinkedList.find(node => node.next === webItem.prev);
                const temp = { ...prevNode };
                const tempWeb = { ...prevWebNode };

                temp.next = null;
                tempWeb.next = null;

                newLinkedList = linkedList.filter(node => node.id !== item.id);
                newWebLinkedList = webLinkedList.filter(node => node.id !== webItem.id);

                const prevIndex = newLinkedList.findIndex(node => node.id === prevNode.id);
                const prevWebIndex = newWebLinkedList.findIndex(node => node.id === prevWebNode.id);

                newLinkedList[prevIndex] = temp;
                newWebLinkedList[prevWebIndex] = tempWeb;
            }

            // Case 3: At the middle (prev: "", next: "")
            if(item.prev && item.next) {
                const linkId = uuidv4();

                const prevNode = linkedList.find(node => node.next === item.prev);
                const prevWebNode = webLinkedList.find(node => node.next === webItem.prev);
                const nextNode = linkedList.find(node => node.prev === item.next);
                const nextWebNode = webLinkedList.find(node => node.prev === webItem.next);

                const temp = { ...prevNode };
                const tempWeb = { ...prevWebNode };
                const temp2 = { ...nextNode };
                const tempWeb2 = { ...nextWebNode };

                temp.next = linkId;
                tempWeb.next = linkId;
                temp2.prev = linkId;
                tempWeb2.prev = linkId;

                newLinkedList = linkedList.filter(node => node.id !== item.id);
                newWebLinkedList = webLinkedList.filter(node => node.id !== webItem.id);

                const prevIndex = newLinkedList.findIndex(node => node.id === prevNode.id);
                const prevWebIndex = newWebLinkedList.findIndex(node => node.id === prevWebNode.id);
                const nextIndex = newLinkedList.findIndex(node => node.id === nextNode.id);
                const nextWebIndex = newWebLinkedList.findIndex(node => node.id === nextWebNode.id);

                newLinkedList[prevIndex] = temp;
                newWebLinkedList[prevWebIndex] = tempWeb;
                newLinkedList[nextIndex] = temp2;
                newWebLinkedList[nextWebIndex] = tempWeb2;
            }

            const versionList = JSON.parse(JSON.stringify(state.versionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                index: newIndex,
                storeAbout: newLinkedList,
                webStoreAbout: newWebLinkedList,
                comment: 'Remove about section'
            }

            state.versionStack.push(newVersion);
            state.versionIndex = newIndex;
        },
        removeDesktopAboutSection: (state, action) => {
            const item = action.payload;

            const currentVersion = JSON.parse(JSON.stringify(state.versionStack[state.versionIndex]));
            const linkedList = currentVersion.storeAbout;

            let newLinkedList = [];

            // Case 1: At the beginning (prev: null, next: "")
            if(!item.prev && item.next) {
                const nextNode = linkedList.find(node => node.prev === item.next);
                const temp = { ...nextNode };

                temp.prev = null;

                newLinkedList = linkedList.filter(node => node.id !== item.id);

                const nextIndex = newLinkedList.findIndex(node => node.id === nextNode.id);

                newLinkedList[nextIndex] = temp;
            }

            // Case 2: At the end (prev: "", next: null)
            if(item.prev && !item.next) {
                const prevNode = linkedList.find(node => node.next === item.prev);
                const temp = { ...prevNode };

                temp.next = null;

                newLinkedList = linkedList.filter(node => node.id !== item.id);

                const prevIndex = newLinkedList.findIndex(node => node.id === prevNode.id);

                newLinkedList[prevIndex] = temp;
            }

            // Case 3: At the middle (prev: "", next: "")
            if(item.prev && item.next) {
                const linkId = uuidv4();

                const prevNode = linkedList.find(node => node.next === item.prev);
                const nextNode = linkedList.find(node => node.prev === item.next);

                const temp = { ...prevNode };
                const temp2 = { ...nextNode };

                temp.next = linkId;
                temp2.prev = linkId;

                newLinkedList = linkedList.filter(node => node.id !== item.id);

                const prevIndex = newLinkedList.findIndex(node => node.id === prevNode.id);
                const nextIndex = newLinkedList.findIndex(node => node.id === nextNode.id);

                newLinkedList[prevIndex] = temp;
                newLinkedList[nextIndex] = temp2;
            }

            const versionList = JSON.parse(JSON.stringify(state.desktopVersionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                index: newIndex,
                storeAbout: newLinkedList,
                comment: 'remove desktop about section'
            }

            state.desktopVersionStack.push(newVersion);
            state.desktopVersionIndex = newIndex;
        },
        updateLogoImage: (state, action) => {
            const currentVersion = JSON.parse(JSON.stringify(state.versionStack[state.versionIndex]));

            const versionList = JSON.parse(JSON.stringify(state.versionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                logoImage: action.payload,
                index: newIndex,
                comment: 'Update logo image'
            }

            state.versionStack.push(newVersion);
            state.versionIndex = newIndex;
        },
        updateBackgroundImage: (state, action) => {
            const currentVersion = JSON.parse(JSON.stringify(state.versionStack[state.versionIndex]));

            const versionList = JSON.parse(JSON.stringify(state.versionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                backgroundImage: action.payload,
                index: newIndex,
                comment: 'Update mobile background image'
            }

            state.versionStack.push(newVersion);
            state.versionIndex = newIndex;
        },
        updateDesktopBackgroundImage: (state, action) => {
            const currentVersion = JSON.parse(JSON.stringify(state.versionStack[state.versionIndex]));

            const versionList = JSON.parse(JSON.stringify(state.versionStack));
            const newIndex = versionList[versionList.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                backgroundImage: action.payload,
                webBackgroundImage: action.payload,
                index: newIndex,
                comment: 'Update desktop background image'
            }

            state.versionStack.push(newVersion);
            state.versionIndex = newIndex;
        },
        setVersionList: (state, action) => {
            state.versionStack = [ action.payload ];
        },
        setDesktopVersionList: (state, action) => {
            state.desktopVersionStack = [ action.payload ];
        },
        pushToVersions: (state, action) => {
            state.versionStack.push(action.payload);
        },
        pushToDesktopVersions: (state, action) => {
            state.desktopVersionStack.push(action.payload);
        },
        updateVersionIndex: (state, action) => {
            state.versionIndex = action.payload;
        },
        updateDesktopVersionIndex: (state, action) => {
            state.desktopVersionIndex = action.payload;
        },
        popFromVersions: (state, action) => {
            state.versionStack.pop(action.payload);
        },
        setCategoryCollectionToEdit: (state, action) => {
            state.categoryCollectionToEdit = action.payload;
        },
        setCustomCollectionToEdit: (state, action) => {
            state.customCollectionToEdit = action.payload;
        },
        setCategoryToEdit: (state, action) => {
            state.categoryToEdit = action.payload;
        },
        setSelectionType: (state, action) => {
            state.mediaSelectionType = action.payload;
        },
        openPreview: (state, action) => {
            state.displayPreview.type = action.payload;
            state.displayPreview.open = true;
        },
        closePreview: (state, _) => {
            state.displayPreview = initialStateValue.displayPreview;
        },
        setChangeType: (state, action) => {
            state.changeType = action.payload;
        },
        setPageTypeDropdownOpen: (state, action) => {
            state.pageTypeDropdownOpen = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchMedia.pending, (state) => {
            state.media.loading = 'loading';
        })
        .addCase(fetchMedia.fulfilled, (state, action) => {
            state.media.loading = 'succeeded';
            state.media.media = action.payload;
        })
        .addCase(fetchMedia.rejected, (state, action) => {
            state.media.loading = 'failed';
            state.media.error = action.error.message;
        })
        .addCase(fetchStorefront.pending, (state) => {
            state.storefront.loading = 'loading';
        })
        .addCase(fetchStorefront.fulfilled, (state, action) => {
            state.storefront.loading = 'succeeded';
            state.storefront.storefront = action.payload;
        })
        .addCase(fetchStorefront.rejected, (state, action) => {
            state.storefront.loading = 'failed';
            state.storefront.error = action.error.message;
        })
        .addCase(fetchStorefrontAbout.pending, (state) => {
            state.storefrontAbout.loading = 'loading';
        })
        .addCase(fetchStorefrontAbout.fulfilled, (state, action) => {
            state.storefrontAbout.loading = 'succeeded';
            state.storefrontAbout.storefrontAbout = action.payload;
        })
        .addCase(fetchStorefrontAbout.rejected, (state, action) => {
            state.storefrontAbout.loading = 'failed';
            state.storefrontAbout.error = action.error.message;
        })
    },
});

export const {
    setProps,
    toggleButtonClick,
    setViewtype,
    setPagetype,
    setSectionType,
    updateZoomSize,
    setSectionFormType,
    setModal,
    closeModal,
    setSelectedCarouselBannerSection,
    setEditLinkedList,
    moveSectionUp,
    moveSectionDown,
    setVersionList,
    pushToVersions,
    popFromVersions,
    updateVersionIndex,
    addItemToLast,
    setCategoryCollectionToEdit,
    setCategoryToEdit,
    setSelectionType,
    removeSection,
    updateBackgroundImage,
    addAboutItemToLast,
    setSelectedFeatureOneSection,
    setSelectedFeatureTwoSection,
    setCustomCollectionToEdit,
    removeAboutSection,

    pushToDesktopVersions,
    updateDesktopVersionIndex,
    setDesktopVersionList,
    addDesktopItemToLast,
    setDesktopEditLinkedList,
    moveDesktopSectionUp,
    moveDesktopSectionDown,
    removeDesktopSection,
    updateDesktopBackgroundImage,
    addDesktopAboutItemToLast,
    removeDesktopAboutSection,
    setSelectedDesktopFeatureOneSection,
    setSelectedDesktopFeatureTwoSection,
    openPreview,
    closePreview,
    updateLogoImage,
    setChangeType,
    setPageTypeDropdownOpen,
} = storefrontSlice.actions;


export {
    fetchMedia,
    fetchStorefront,
    fetchStorefrontAbout,
}

export default storefrontSlice.reducer;
